import axios from "../../axios";

export const getIrregularities = async (accountId, aggregated = false) => {
  try {
    const url = aggregated ? `/api/v3/aggregate/analysis/irregularities?reportReferenceId=${accountId}` : `/api/v3/analysis/irregularities?accountId=${accountId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};
